import { CircularProgress, FabProps } from '@material-ui/core';
import React from 'react';
import { Fab } from './fab/fab';

interface FloatingdButtonProps extends FabProps {
  isLoading?: boolean;
}

/**
 * @DEPRECATED use Fab from ./fab.tsx instead
 */
export function FloatingdButton({ isLoading, children, ...rest }: FloatingdButtonProps) {
  return <Fab {...rest}>{isLoading ? <CircularProgress color="secondary" size={16} /> : children}</Fab>;
}
